export const showBack = (state) => state.back.show
export const getMapOptions = (state) => state.mapOptions
export const showMap = (state) => state.showMap
